module.exports = __webpack_public_path__ + "img/visa-small.8d8e4715.svg";